import { Type } from "@sinclair/typebox";
import { Value } from "@sinclair/typebox/value";
import { AGENT_MESSAGE_KEY } from "./agent-message.ts";
import { USER_AUTOMATION_ROOT_KEY, type UserAutomationRoot } from "./user-automation.ts";
import { verifiedUserAutomationRoot } from "./user-automation-message.ts";

export const THREAD_ROOT_KEY = "io.matrix_idp.thread.root" as const;
export const ThreadRootSchema = Type.Object({
  version: Type.Literal("1.0"),
  agentKey: Type.String({ minLength: 1, maxLength: 128 })
}, { additionalProperties: false });

export interface ThreadRootEvent {
  roomId: string | undefined;
  eventId: string | undefined;
  sender: string | undefined;
  type: string;
  redacted: boolean;
  content: Record<string, unknown>;
}

export type DirectChatThreadRoot =
  | { kind: "human"; prompt: string }
  | { kind: "user_automation"; prompt: string; automation: UserAutomationRoot };

export function verifiedDirectChatThreadRoot(
  event: ThreadRootEvent,
  trusted: { roomId: string; botMxid: string; agentKey: string; humanMxid: string }
): DirectChatThreadRoot | null {
  const { content } = event;
  const marker = content[THREAD_ROOT_KEY];
  if (
    !event.eventId || event.roomId !== trusted.roomId ||
    !trusted.humanMxid || !trusted.botMxid || trusted.humanMxid === trusted.botMxid ||
    event.type !== "m.room.message" || event.redacted ||
    content.msgtype !== "m.text" || typeof content.body !== "string" || !content.body.trim() ||
    content["m.relates_to"] !== undefined || content[AGENT_MESSAGE_KEY] !== undefined ||
    !Value.Check(ThreadRootSchema, marker) || marker.agentKey !== trusted.agentKey
  ) return null;

  if (content[USER_AUTOMATION_ROOT_KEY] !== undefined) {
    const automation = verifiedUserAutomationRoot(event, trusted);
    return automation ? { kind: "user_automation", prompt: automation.prompt, automation } : null;
  }
  return event.sender === trusted.humanMxid ? { kind: "human", prompt: content.body } : null;
}
